import localDataStorage from '../store/localDataStorage'
import { APIURL } from './URL';

// const globalUrl = APIURL;
const globalUrl = process.env.REACT_APP_API_URL;

const getAuthToken = () => {
    return localDataStorage.getLocalStorage('authToken');
};

const apiCaller = async ({ apiUrl, method = 'POST', body = null, headers = {} }) => {

    const token = getAuthToken();
    const url = globalUrl + apiUrl

    const defaultHeaders = {
        ...headers,
        // "Content-Type": "application/x-www-form-urlencoded",
        "Content-Type": "application/json",
        //  ...(token && { 'Authorization': `Bearer ${token}` }) // Add token to header if available
    };

    const encodeParams = (params) => {
        return Object.keys(params)
            .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(params[key]))
            .join('&');
    };

    const config = {
        method: method,
        headers: defaultHeaders,
        body: body ? JSON.stringify(body) : null,
    };

    try {
        const response = await fetch(url, config);

        // Check if response is successful
        if (!response.ok) {
            throw new Error(`API request failed with status: ${response.status}`);
        }

        // If response is not base64 (not encrypted), attempt to parse as JSON
        try {
            return await response.json();
        } catch (jsonError) {
            throw jsonError;
        }

    } catch (error) {
        console.error('API call failed:', error);
        throw error;
    }
};

export default apiCaller;
